export function useSiteAvailability() {
  const isApiAvailable = useState<boolean | null>('site-api-available', () => null);

  return { isApiAvailable };
}
